export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/a2cdf02300b2663230f496dbfe02b4a0.svg";